export default "/fr/_next/static/assets/images/sprite.a94d4dc98fc0f0c14881e499b1aa4e42.svg";